<template>
  <div class="post-wrapper" v-bar="{
      useScrollbarPseudo: true,
      overrideFloatingScrollbar: true,
    }">
    <div class="posts" @scroll="test" id="top" v-if="isPosts">
      <template v-if="!reqPending || isPopularLoaded">
        <h2 class="popular-title">
          Топ постов за сегодня
        </h2>
        <popular-posts :popular-posts="popularPosts"/>
        <div class="divider"></div>
      </template>
      <post-preview :posts="postsFilteredByCheckboxType" v-if="items.length"/>
      <table-preloader v-if="reqPending" style="margin-top: 4em"/>
    </div>
    <div class="posts" id="top" v-else>
      По данной ленте постов нет.
    </div>
    <scroll-top-button @onScroll="handleScroll" v-if="position"/>
  </div>
</template>

<script>
import PopularPosts from './components/popularPosts/PopularPosts.vue';
import Post from './post.vue';
import PostPreview from './components/postPreview/postPreview.vue';
import { getPostsApi } from '../../../../api/posts';
import { getPostTopApi } from '../../../../api/popular';
import TablePreloader from '../../../../components/preLoaders/tablePreloader.vue';
import { SET_POSTS_COUNT } from '../../../../store/actions/threadInfo';
import ShowMenuBtn from './components/showMenuBtn.vue';
import ScrollTopButton from './components/ScrollTopButton.vue';

// libraries
import moment from 'moment/moment';

// vuex
import { mapGetters } from 'vuex';

export default {
  name: 'posts',
  components: {
    ShowMenuBtn,
    TablePreloader,
    PostPreview,
    Post,
    ScrollTopButton,
    PopularPosts,
  },
  data() {
    return {
      items: [],
      isPosts: true,
      moment,
      reqPending: false,
      count: '',
      start: 0,
      postRequestTimeout: '',
      position: 0,
      popular: {
        startTime: '00:00:00',
        endTime: '23:59:59',
        format: 'YYYY-MM-DD',
        setDateTime: time => `${moment().format(this.popular.format)} ${time}`,
      },
      popularPosts: {
        vk: {
          params: {
            thread_id: null,
            network_id: 1,
            post_count: 1,
          },
          data: [],
          loaded: false,
        },
        tw: {
          params: {
            thread_id: null,
            network_id: 2,
            post_count: 1,
          },
          data: [],
          loaded: false,
        },
        fb: {
          params: {
            thread_id: null,
            network_id: 3,
            post_count: 1,
          },
          data: [],
          loaded: false,
        },
        gs: {
          params: {
            thread_id: null,
            network_id: 4,
            post_count: 3,
          },
          data: [],
          loaded: false,
        },
      },
    };
  },
  methods: {
    test($event) {
      const element = $event.target;
      this.updateContentScrollPosition(element);

      if (element.scrollHeight - element.scrollTop >= element.clientHeight) {
        if (this.items.length + 1 < this.count) {
          this.getPosts(this.$route.params.id);
        }
      }
    },
    updateContentScrollPosition(element) {
      this.position = element.scrollTop;
    },
    handleScroll() {
      let elem = document.querySelector("#top");
      elem.scrollTop = 0;
    },
    getPosts(id) {
      if (!this.reqPending) {
        this.start = this.items.length;

        this.reqPending = true;
        const params = {
          thread_id: id,
          limit: 20,
          start: this.start,
          sort: {
            type: 'date',
            order: 'desc',
          },
        };
        this.postRequestTimeout = setTimeout(() => {
          this.$root.$emit('postRequestTimeout');
        }, 180000);
        getPostsApi(params)
          .then((req) => {
            this.items = this.items.concat(req.data.posts);
            this.reqPending = false;
            this.count = req.data.count;
            this.$store.dispatch(SET_POSTS_COUNT, this.count);
            this.$root.$emit('postsLoaded');

            this.isPosts = this.items.length;

            clearTimeout(this.postRequestTimeout);
          });
      }
    },
    getPopularPostParams(social) {
      this.popularPosts[social].params.thread_id = this.$route.params.id;
      return {
        ...this.popularPosts[social].params,
        from: this.popular.setDateTime(this.popular.startTime),
        to: this.popular.setDateTime(this.popular.endTime),
      };
    },
    getPostTop() {
      this.reqPending = true;

      Object.keys(this.popularPosts).forEach((key) => {
        getPostTopApi(this.getPopularPostParams(key))
          .then((response) => {
            this.popularPosts[key].data = response.data;
            this.popularPosts[key].loaded = true;
          });
      });
    },
    getHeight() {
      const headerHeight = window.document.querySelector('.header').offsetHeight;
      document.querySelector('.wrapper').style.height =
        `${document.body.offsetHeight - headerHeight - document.querySelector('.work-area').style.marginTop - document.querySelector('.work-area').style.marginBottom}px`;
    },
    clearPopularPostsData() {
      const popularPostsKeys = Object.keys(this.popularPosts);
      popularPostsKeys.forEach((key) => {
        this.popularPosts[key].data = [];
      });
    },
  },
  computed: {
    ...mapGetters([
      'threadName',
    ]),
    isPopularLoaded() {
      const popularPostsKeys = Object.keys(this.popularPosts);
      let isLoaded = true;
      const loadedData = [];
      popularPostsKeys.forEach((key) => {
        isLoaded = this.popularPosts[key].loaded;
        loadedData.push(...this.popularPosts[key].data);
      });

      return isLoaded && loadedData.length > 0;
    },
    postsFilteredByCheckboxType() {
      const types = this.$store.state.posts.postTypesToShow;
      if (types.length !== 2) {
        if (types[0] === 'soc') {
          return this.items.filter(post => post.network_name !== 'gs');
        } if (types[0] === 'smi') {
          return this.items.filter(post => post.network_name === 'gs');
        }
        return this.items;
      }
      return this.items;
    },
  },
  mounted() {
    this.items = [];
    this.count = '';
    this.getPosts(this.$route.params.id);
    this.getPostTop();
    // this.getHeight();
  },
  watch: {
    $route() {
      this.items = [];
      this.getPosts(this.$route.params.id);
      this.clearPopularPostsData();
      this.getPostTop();
    },
  },
};
</script>

<style lang="stylus">
.post-wrapper {
  position relative
  overflow-y: auto;
  height: calc(100vh - 85px);
}
.posts {

}
.popular-title
  padding 0
  margin -5px 0 20px 0
  font-family "Oswald", "Arial", sans-serif
  font-style normal
  font-weight 300
  font-size 18px
  line-height 50px
  letter-spacing 0.1em
  text-transform uppercase
.divider
  margin-bottom  20px
  height 20px
  background-color #e5e5e5
</style>
